<div class="reference_body">
  <main class="reference_main">
    <div class="pink_box"></div>
    <div class="green_box"></div>

    <div class="main">
      <div class="reference_table">
        <div class="container">
        <div class="top">
          <div class="row">
            <div class="col-md-8">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item active" aria-current="page"> <h3 >Scholarship<em class="ti-info-alt ml-3" style="font-size: 12px;"></em> </h3></li>  
                </ol>
              </nav>

            </div>
            <div class="col-md-4">
              <div class=" pull-right">
                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" color="accent" class="m-3">

                  <mat-button-toggle value="grid" (click)="onBack()"><mat-icon class="example-tab-icon">arrow_back</mat-icon> Back to Scholarship</mat-button-toggle>

                </mat-button-toggle-group>
                <!-- <button mat-raised-button color="primary"  (click)="filterProjectModal()"> <mat-icon class="example-tab-icon">filter_list</mat-icon> Filter Project</button> -->
               </div>
            </div>
          </div>



        </div>

    <div class="row">

      <div class="col-lg-12 col-md-12">

        <form [formGroup]="scholarshipManagementForm"  >

          <div class="row">
            <div class="col-md-12 ">
                  <mat-horizontal-stepper  #stepper>

               <div class="row">
                 <div class="col-lg-4">
                  <ng-template  matStepperIcon="edit" >
                    <mat-icon>done</mat-icon>
                  </ng-template>
                 </div>
              </div>

              <mat-step>
                <ng-template matStepLabel>Beneficiary's Personal Information</ng-template>
                <div class="row">
                  <!-- <div class="col-md-4">

                   <mat-form-field class="full-width-field" id="id_number">
                     <mat-select placeholder="Select scholarship category" formControlName="ScholarshipCategoryId" (selectionChange)="selectScholarshipCategory($event)">
                     <mat-option *ngFor="let scholarshipCategory of scholarshipCategories" [value]="scholarshipCategory.id">{{scholarshipCategory.ScholarshipCategoryName}}</mat-option>
                     </mat-select>
                     <mat-error *ngIf="errorHandling('ScholarshipCategoryId', 'required')">
                       You must provide <strong>Scholarship category</strong>
                    </mat-error>
                     </mat-form-field>

                  </div> -->
                  <div class="col-md-4">

                    <mat-form-field  class="full-width-field" id="id_number">
                      <mat-select placeholder="Select scholarship type" #singleSelect formControlName="ScholarshipTypeId" >
                        <ngx-mat-select-search [formControl]="scholarshipCategoryGroupsFilterCtrl"></ngx-mat-select-search>
                        <mat-option>None</mat-option>
                        <mat-optgroup *ngFor="let group of filteredScholarshipTypeGroups | async" [label]="group.ScholarshipCategoryName">

                          <mat-option *ngFor="let type of group.scholarshipTypes" [value]="type.id">


                              {{type.ScholarshipTypeName}}


                          </mat-option>

                        </mat-optgroup>
                      </mat-select>
                    </mat-form-field>

                 </div>

                  <!-- <div class="col-md-4">

                   <mat-form-field class="full-width-field" id="id_number">
                     <mat-select placeholder="Select scholarship type" formControlName="ScholarshipTypeId" >
                     <mat-option *ngFor="let scholarshipType of filteredScholarshipType" [value]="scholarshipType.id">{{scholarshipType.ScholarshipTypeName}}</mat-option>
                     </mat-select>
                     <mat-error *ngIf="errorHandling('ScholarshipTypeId', 'required')">
                       You must provide <strong>Scholarship category</strong>
                    </mat-error>
                     </mat-form-field>

                  </div> -->

                  <div class="col-md-4">

                    <mat-form-field class="full-width-field" id="id_number">
                      <input matInput placeholder="Enter Beneficiary Surname" formControlName="BeneficarySurname"  >

                      <mat-error *ngIf="errorHandling('BeneficarySurname', 'required')">
                         You must provide <strong>Beneficiary surname</strong>
                      </mat-error>
                   </mat-form-field>

                   </div>

                   <div class="col-md-4">
                    <mat-form-field class="full-width-field" id="id_number">
                      <input matInput placeholder="Enter Beneficiary First Name" formControlName="BeneficaryFirstname" >

                      <mat-error *ngIf="errorHandling('BeneficaryFirstname', 'required')">
                         You must provide <strong>Beneficiary first name</strong>
                      </mat-error>
                   </mat-form-field>
                  </div>
                </div>

               <div class="row">



                <div class="col-md-4">
                  <mat-form-field class="full-width-field" id="id_number">
                    <input matInput placeholder="Enter Beneficary other name" formControlName="BeneficaryOthername"  >

                    <mat-error *ngIf="errorHandling('BeneficaryOthername', 'required')">
                       You must provide <strong>Beneficary other name</strong>
                    </mat-error>
                 </mat-form-field>
                </div>

                <div class="col-md-4">
                  <mat-form-field class="full-width-field" id="id_number">
                    <input matInput placeholder="Enter Scholarship award No" formControlName="ScholarshipAwardNo"  >

                    <mat-error *ngIf="errorHandling('ScholarshipAwardNo', 'required')">
                       You must provide <strong>Scholarship award No</strong>
                    </mat-error>
                 </mat-form-field>
                </div>

                <div class="col-md-4">
                  <mat-form-field class="full-width-field" id="id_number">
                    <input matInput placeholder="Enter Scholarship application No" formControlName="ScholarshipApplicationNo"  >

                    <mat-error *ngIf="errorHandling('ScholarshipApplicationNo', 'required')">
                       You must provide <strong>Scholarship application No</strong>
                    </mat-error>
                 </mat-form-field>
                </div>

              </div>

              <div class="row">

                <div class="col-md-4">

                 <mat-form-field class="full-width-field" id="id_number">
                   <mat-select placeholder="Select scholarship session" formControlName="ScholarshipYear" >
                   <mat-option *ngFor="let scholarshipSession of scholarshipSessions" [value]="scholarshipSession.id">{{scholarshipSession.ScholarshipSessionName}}</mat-option>
                   </mat-select>
                   <mat-error *ngIf="errorHandling('ScholarshipYear', 'required')">
                     You must provide <strong>Scholarship session</strong>
                  </mat-error>
                   </mat-form-field>

                </div>

                <div class="col-md-4">
                  <mat-form-field class="full-width-field" id="id_number">

         <input matInput [matDatepicker]="picker" formControlName="ScholarshipDate" placeholder="Select scholarship date">
         <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
         <mat-datepicker #picker></mat-datepicker>
         <mat-hint></mat-hint>

                    <mat-error *ngIf="errorHandling('ScholarshipDate', 'required')">
                       You must provide <strong>scholarship date</strong>
                    </mat-error>
                 </mat-form-field>

                </div>

                <div class="col-md-4">

                  <mat-form-field class="full-width-field" id="id_number">
                    <mat-select placeholder="Select gender" formControlName="Gender" >
                    <mat-option *ngFor="let gender of genders" [value]="gender.id">{{gender.GenderName}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="errorHandling('Gender', 'required')">
                      You must provide <strong>gender</strong>
                   </mat-error>
                    </mat-form-field>

                 </div>

              </div>


              <div class="row">


                <div class="col-md-4">
                  <mat-form-field class="full-width-field" id="id_number">
                    <input matInput [matDatepicker]="picker1" formControlName="DateOfBirth" placeholder="Date of Birth">
         <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
         <mat-datepicker #picker1></mat-datepicker>
         <mat-hint></mat-hint>

                    <mat-error *ngIf="errorHandling('DateOfBirth', 'required')">
                       You must provide <strong>Date of Birth</strong>
                    </mat-error>
                 </mat-form-field>
                </div>

                <div class="col-md-4">

                    <mat-form-field  class="full-width-field" id="id_number">
                      <mat-select placeholder="Select LGA" #singleSelect formControlName="LGA" (selectionChange)="selectLgaBeneficiary($event)">
                        <ngx-mat-select-search [formControl]="countryGroupsFilterCtrl"></ngx-mat-select-search>
                        <mat-option>None</mat-option>
                        <mat-optgroup *ngFor="let group of filteredStateGroups | async" [label]="group.StateName">

                          <mat-option *ngFor="let lga of group.lgas" [value]="lga.id">


                              {{lga.LgaName}}


                          </mat-option>

                        </mat-optgroup>
                      </mat-select>
                    </mat-form-field>

                 </div>

                 <div class="col-md-4">

                  <mat-form-field class="full-width-field" id="id_number">
                    <mat-select placeholder="Select community" formControlName="Community" >
                    <mat-option *ngFor="let community of filteredCommunityBeneficiary" [value]="community.id">{{community.CommunityName}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="errorHandling('Community', 'required')">
                      You must provide <strong>community</strong>
                   </mat-error>
                    </mat-form-field>

                 </div>

              </div>

              <div class="row">



                <div class="col-md-4">

                  <mat-form-field class="full-width-field" id="id_number">
                    <input matInput placeholder="Enter phone number" formControlName="PhoneNumber"  >

                    <mat-error *ngIf="errorHandling('PhoneNumber', 'required')">
                       You must provide <strong>phone number</strong>
                    </mat-error>
                 </mat-form-field>

                 </div>

                 <div class="col-md-4 mt-5">
                   <label for="">Upload Passport</label>
                  <input type="file"  (change)="onImagePicked($event)" id="id_number"  placeholder="">
               </div>

               <div class="col-md-4">

                <mat-form-field class="full-width-field" id="id_number">
                  <textarea  matInput placeholder="Enter Address" formControlName="Address"  ></textarea>

                  <mat-error *ngIf="errorHandling('Address', 'required')">
                     You must provide <strong>Address</strong>
                  </mat-error>
               </mat-form-field>

               </div>

              </div>


              </mat-step>

              <mat-step>
                <ng-template matStepLabel>Applicant Details Before Award</ng-template>
                <div class="row">
                  <div class="col-md-4">
                    <mat-form-field class="full-width-field" id="id_number">
                      <mat-select placeholder="Select institution LGA " formControlName="InstitutionLGABeforeAward" (selectionChange)="selectLgaBeforeAward($event)">

                        <div *ngFor="let level1 of countries">
                          <mat-optgroup *ngIf="level1.CountryName else leaf"  [label]="level1.CountryName">
                            <mat-select>

                              <div *ngFor="let level2 of level1.states">
                                <mat-optgroup *ngIf="level2.StateName else leaf"  [label]="level2.StateName">
                                  <mat-select>

                                    <mat-option *ngFor="let level3 of level2.lgas" [value]="level3.id">{{level3.LgaName}}</mat-option>

                                  </mat-select>
                                </mat-optgroup>
                                <ng-template #leaf>
                                  <mat-option [value]="level2.id">{{level1.CountryName + ' ' + level2.StateName}}</mat-option>
                                </ng-template>
                              </div>

                            </mat-select>
                          </mat-optgroup>
                          <ng-template #leaf>
                            <mat-option [value]="level1.id">{{level1.CountryName}}</mat-option>
                          </ng-template>
                        </div>

                      </mat-select>
                    </mat-form-field>
                   </div>

                   <div class="col-md-4">

                    <mat-form-field class="full-width-field" id="id_number">
                      <mat-select placeholder="Select institution community" formControlName="InstitutionCommunityBeforeAward" >
                      <mat-option *ngFor="let community of filteredCommunityBeforeAward" [value]="community.id">{{community.CommunityName}}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="errorHandling('InstitutionCommunityBeforeAward', 'required')">
                        You must provide <strong>Institution community before award</strong>
                     </mat-error>
                      </mat-form-field>

                   </div>

                   <div class="col-md-4">

                    <mat-form-field class="full-width-field" id="id_number">
                      <input matInput placeholder="Enter institution name" formControlName="InstitutionNameBeforeAward"  >

                      <mat-error *ngIf="errorHandling('InstitutionNameBeforeAward', 'required')">
                         You must provide <strong>Institution name before award</strong>
                      </mat-error>
                   </mat-form-field>

                   </div>

                  <!-- <div class="col-md-4">

                    <mat-form-field class="full-width-field" id="id_number">
                      <mat-select placeholder="Select institution country" formControlName="InstitutionCountryIdBeforeAward" >
                      <mat-option *ngFor="let country of countries" [value]="country.id">{{country.CountryName}}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="errorHandling('InstitutionCountryIdBeforeAward', 'required')">
                        You must provide <strong>Institution country award</strong>
                     </mat-error>
                      </mat-form-field>

                   </div>

                  <div class="col-md-4">

                    <mat-form-field class="full-width-field" id="id_number">
                      <mat-select placeholder="Select institution state" formControlName="InstitutionStateIdBeforeAward" >
                      <mat-option *ngFor="let state of states" [value]="state.id">{{state.StateName}}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="errorHandling('InstitutionStateIdBeforeAward', 'required')">
                        You must provide <strong>Institution state before award</strong>
                     </mat-error>
                      </mat-form-field>

                   </div>

                  <div class="col-md-4">

                   <mat-form-field class="full-width-field" id="id_number">
                     <mat-select placeholder="Select institution LGA " formControlName="InstitutionLGABeforeAward" >
                     <mat-option *ngFor="let lga of lgas" [value]="lga.id">{{lga.LgaName}}</mat-option>
                     </mat-select>
                     <mat-error *ngIf="errorHandling('InstitutionLGABeforeAward', 'required')">
                       You must provide <strong>Institution LGA before award</strong>
                    </mat-error>
                     </mat-form-field>

                  </div> -->

                </div>

                <div class="row">



                   <div class="col-md-4">

                    <mat-form-field class="full-width-field" id="id_number">
                      <input matInput placeholder="Enter contact person" formControlName="ContactPerson"  >

                      <mat-error *ngIf="errorHandling('ContactPerson', 'required')">
                         You must provide <strong>contact person</strong>
                      </mat-error>
                   </mat-form-field>

                   </div>

                   <div class="col-md-4">

                    <mat-form-field class="full-width-field" id="id_number">
                      <input matInput placeholder="Enter contact phone number" formControlName="ContactPhoneNo"  >

                      <mat-error *ngIf="errorHandling('ContactPhoneNo', 'required')">
                         You must provide <strong>contact phone number</strong>
                      </mat-error>
                   </mat-form-field>

                   </div>

                   <div class="col-md-4">

                    <mat-form-field class="full-width-field" id="id_number">
                      <input matInput placeholder="Enter contact email" formControlName="ContactEmail"  >

                      <mat-error *ngIf="errorHandling('ContactEmail', 'required')">
                         You must provide <strong>contact email</strong>
                      </mat-error>
                   </mat-form-field>

                   </div>
                </div>




                <div class="row">

                   <div class="col-md-6">

                    <mat-form-field class="full-width-field" id="id_number">
                      <textarea matInput placeholder="Enter institution address " formControlName="InstitutionAddressBeforeAward"  ></textarea>

                      <mat-error *ngIf="errorHandling('InstitutionAddressBeforeAward', 'required')">
                         You must provide <strong>Institution address before award</strong>
                      </mat-error>
                   </mat-form-field>

                   </div>

                   <div class="col-md-6">

                    <mat-form-field class="full-width-field" id="id_number">
                      <textarea matInput placeholder="Enter remarks " formControlName="RemarksBeforeAward"  ></textarea>

                      <mat-error *ngIf="errorHandling('RemarksBeforeAward', 'required')">
                         You must provide <strong>Remarks before award</strong>
                      </mat-error>
                   </mat-form-field>

                   </div>

                </div>

                </mat-step>

                <mat-step>
                  <ng-template matStepLabel>Applicant Details On Award</ng-template>

                  <div class="row">

                    <div class="col-md-4">

                      <mat-form-field class="full-width-field" id="id_number">
                        <input matInput placeholder="Enter institution name" formControlName="InstitutionNameOnAward"  >

                        <mat-error *ngIf="errorHandling('InstitutionNameOnAward', 'required')">
                           You must provide <strong>Institution name on award</strong>
                        </mat-error>
                     </mat-form-field>

                     </div>

                     <div class="col-md-4">
                      <mat-form-field class="full-width-field" id="id_number">
                        <mat-select placeholder="Select institution LGA " formControlName="InstitutionLGAOnAward" (selectionChange)="selectLgaOnAward($event)">

                          <div *ngFor="let level1 of countries">
                            <mat-optgroup *ngIf="level1.CountryName else leaf"  [label]="level1.CountryName">
                              <mat-select>

                                <div *ngFor="let level2 of level1.states">
                                  <mat-optgroup *ngIf="level2.StateName else leaf"  [label]="level2.StateName">
                                    <mat-select>

                                      <mat-option *ngFor="let level3 of level2.lgas" [value]="level3.id">{{level3.LgaName}}</mat-option>

                                    </mat-select>
                                  </mat-optgroup>
                                  <ng-template #leaf>
                                    <mat-option [value]="level2.id">{{level1.CountryName + ' ' + level2.StateName}}</mat-option>
                                  </ng-template>
                                </div>

                              </mat-select>
                            </mat-optgroup>
                            <ng-template #leaf>
                              <mat-option [value]="level1.id">{{level1.CountryName}}</mat-option>
                            </ng-template>
                          </div>

                        </mat-select>
                      </mat-form-field>
                     </div>

                     <div class="col-md-4">

                      <mat-form-field class="full-width-field" id="id_number">
                        <mat-select placeholder="Select institution community" formControlName="InstitutionCommunityOnAward" >
                        <mat-option *ngFor="let community of filteredCommunityOnAward" [value]="community.id">{{community.CommunityName}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="errorHandling('InstitutionCommunityOnAward', 'required')">
                          You must provide <strong>Institution community on award</strong>
                       </mat-error>
                        </mat-form-field>

                     </div>

                    <!-- <div class="col-md-4">

                      <mat-form-field class="full-width-field" id="id_number">
                        <mat-select placeholder="Select institution country" formControlName="InstitutionCountryIdOnAward" >
                        <mat-option *ngFor="let country of countries" [value]="country.id">{{country.CountryName}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="errorHandling('InstitutionCountryIdOnAward', 'required')">
                          You must provide <strong>Institution country on award</strong>
                       </mat-error>
                        </mat-form-field>

                     </div> -->

                    <!-- <div class="col-md-4">

                      <mat-form-field class="full-width-field" id="id_number">
                        <mat-select placeholder="Select institution state" formControlName="InstitutionStateIdOnAward" >
                        <mat-option *ngFor="let state of states" [value]="state.id">{{state.StateName}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="errorHandling('InstitutionStateIdOnAward', 'required')">
                          You must provide <strong>Institution state on award</strong>
                       </mat-error>
                        </mat-form-field>

                     </div> -->


                  </div>

                  <div class="row">
                    <div class="col-md-4">

                      <mat-form-field class="full-width-field" id="id_number">
                        <input matInput placeholder="Enter contact person name" formControlName="ContactPersonOnAward"  >

                        <mat-error *ngIf="errorHandling('ContactPersonOnAward', 'required')">
                           You must provide <strong>person name on award</strong>
                        </mat-error>
                     </mat-form-field>

                     </div>

                     <div class="col-md-4">

                      <mat-form-field class="full-width-field" id="id_number">
                        <input matInput placeholder="Enter contact phone number" formControlName="ContactPhoneNoOnAward"  >

                        <mat-error *ngIf="errorHandling('ContactPhoneNoOnAward', 'required')">
                           You must provide <strong>contact phone number on award</strong>
                        </mat-error>
                     </mat-form-field>

                     </div>

                     <div class="col-md-4">

                      <mat-form-field class="full-width-field" id="id_number">
                        <input matInput placeholder="Enter contact person email" formControlName="ContactEmailOnAward"  >

                        <mat-error *ngIf="errorHandling('ContactEmailOnAward', 'required')">
                           You must provide <strong>contact email on award</strong>
                        </mat-error>
                     </mat-form-field>

                     </div>
                  </div>

                  <div class="row">

                    <!-- <div class="col-md-4">

                      <mat-form-field class="full-width-field" id="id_number">
                        <mat-select placeholder="Select institution LGA "  >
                        <mat-option *ngFor="let lga of lgas" [value]="lga.id">{{lga.LgaName}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="errorHandling('InstitutionLGAOnAward', 'required')">
                          You must provide <strong>Institution LGA on award</strong>
                       </mat-error>
                        </mat-form-field>

                     </div> -->
                     <div class="col-md-4">

                      <mat-form-field class="full-width-field" id="id_number">
                        <input matInput placeholder="Enter contact url" formControlName="ContactUrlOnAward"  >

                        <mat-error *ngIf="errorHandling('ContactUrlOnAward', 'required')">
                           You must provide <strong>contact url on award</strong>
                        </mat-error>
                     </mat-form-field>

                     </div>


                     <div class="col-md-4">
                      <mat-form-field class="full-width-field" id="id_number">
                        <mat-select placeholder="Select duration" formControlName="ScholarshipAwardDurationId" >
                        <mat-option *ngFor="let duration of scholarshipAwardDurations" [value]="duration.id">{{duration.ScholarshipAwardDurationName}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="errorHandling('ScholarshipAwardDurationId', 'required')">
                          You must provide <strong>duration</strong>
                       </mat-error>
                        </mat-form-field>


                     </div>

                     <div class="col-md-4">
                      <mat-form-field class="full-width-field" id="id_number">
                        <mat-select placeholder="Select course of study" formControlName="CourseOfStudy" >
                        <mat-option *ngFor="let courseOfStudy of courseOfStudies" [value]="courseOfStudy.id">{{courseOfStudy.CourseOfStudyName}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="errorHandling('CourseOfStudy', 'required')">
                          You must provide <strong>course of study</strong>
                       </mat-error>
                        </mat-form-field>
                     </div>



                  </div>

                  <div class="row">

                    <div class="col-md-6">

                     <mat-form-field class="full-width-field" id="id_number">
                       <textarea matInput placeholder="Enter institution address " formControlName="InstitutionAddressOnAward"  ></textarea>

                       <mat-error *ngIf="errorHandling('InstitutionAddressOnAward', 'required')">
                          You must provide <strong>Institution address on award</strong>
                       </mat-error>
                    </mat-form-field>

                    </div>

                    <div class="col-md-6">

                     <mat-form-field class="full-width-field" id="id_number">
                       <textarea matInput placeholder="Enter remarks" formControlName="RemarksOnAward" ></textarea>

                       <mat-error *ngIf="errorHandling('RemarksOnAward', 'required')">
                          You must provide <strong>Remarks on award</strong>
                       </mat-error>
                    </mat-form-field>

                    </div>

                 </div>


                </mat-step>
              </mat-horizontal-stepper>
            </div>
          </div>

          <div class="submit">

               <button (click)="goBack(stepper)"  *ngIf="stepper.selectedIndex !== 0" class="submit_button mr-3">back &larr;</button>
               <button type="submit" (click)="onSubmit(scholarshipManagementForm.value)" *ngIf="stepper.selectedIndex === totalStepsCount-1" class="submit_button" type="submit">Done  &rarr;</button>

               <button (click)="goForward(stepper)"  *ngIf="stepper.selectedIndex !== totalStepsCount-1"  class="submit_button outside" >Next &rarr;</button>

              </div>

              <!-- <pre>{{scholarshipManagementForm.value | json}}</pre> -->
           </form>
           <ng-template >
           <!-- <button (click)="goForward(stepper)" [disabled]="stepper.selectedIndex === totalStepsCount-1" *ngIf="stepper.selectedIndex !== totalStepsCount-1" class="submit_button outside" >Next &rarr;</button> -->

           </ng-template>

      </div>

    </div>



        <!-- <div class="submit">
          <button class="submit_button" (click)="onSubmit()">
            Submit
          </button>
        </div> -->
        <!-- </form> -->
        </div>
      </div>
    </div>
  </main>
</div>
